import HorizontalTabs from './HorizontalTabs.jsx';

export default HorizontalTabs;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/HorizontalTabs/index.js